//For now we don't have to worry about the environments
const getEnvironment = () => ({
  name: process.env.name ? process.env.name.toLowerCase() : "development",
});

export default getEnvironment;
